<script lang="ts">
	import PostPageTemplate from '../../_components/PostPageTemplate.svelte';

	let { data } = $props();
	let { Post } = data;
</script>

<PostPageTemplate metadata={data.metadata}>
	<Post />
</PostPageTemplate>
